import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function DataIntelligenceGateway() {
  return <section data-section-id="222571" id="hero-section" className="bg-background text-foreground relative min-h-[80vh] flex items-center overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/international_logistics_shipping.png)]" />

      {}
      <div className="absolute inset-0 z-0 bg-primary/85 backdrop-blur-[2px]" />

      {}
      <div className="container mx-auto px-6 md:px-8 relative z-10 w-full max-w-7xl">
        <div className="max-w-2xl flex flex-col items-start">
          <h1 className="font-default text-4xl md:text-5xl lg:text-[56px] font-bold text-white mb-6 leading-tight tracking-tight">
            DOCUMENTI <span className="text-secondary">IMPORT EXPORT</span>
          </h1>
          
          <p className="font-default text-lg md:text-[22px] text-white/90 max-w-[600px] mb-10 leading-relaxed">
            Gestione professionale di documentazione internazionale, pratiche doganali e servizi export per aziende che puntano ai mercati globali.
          </p>
          
          <div className="flex flex-wrap gap-4">
            <Button asChild size="lg" className="bg-[#FFC829] hover:bg-[#FFC829]/90 text-primary border border-secondary rounded-lg text-lg h-14 px-8 shadow-lg transition-all">
              <Link to="/ContactsPage">
                Richiedi Consulenza
              </Link>
            </Button>

            <Button asChild size="lg" className="bg-[#FFC829] hover:bg-[#FFC829]/90 text-primary rounded-lg text-lg h-14 px-8 shadow-lg transition-all">
              <Link to="/DocumentImportExportPage">
                Contattaci per il servizio Export
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}